import React from "react";
import Image from "next/image";
import Body from "components/Body";

export default function NodeEventContent({ node }) {
  return (
    <article>
      {node.field_image?.image_style_uri.large_scale && (
        <div className="overflow-hidden aspect-w-16 aspect-h-9 mb-16 bg-secondary-light">
          <figure>
            <Image
              {...node.field_image.resourceIdObjMeta}
              src={node.field_image.image_style_uri.large_scale}
              layout="fill"
              objectFit="contain"
            />
          </figure>
        </div>
      )}
      {node.body?.processed && (
        <div className="prose max-w-none">
          <Body value={node.body?.processed} />
        </div>
      )}
    </article>
  );
}
